const ConsultationSearchSchema = () => ({
  title: 'AgSUS Consultation Search',
  block: 'agsusConsultationSearch',
  fieldsets: [
    {
      id: 'default',
      title: 'Padrão',
      fields: ['title', 'fonte'],
    },
  ],
  properties: {
    title: {
      title: 'Título',
      type: 'string',
      default: 'Consultas públicas',
    },
    fonte: {
      title: 'Fonte das consultas',
      description:
        'Pasta cujos filhos diretos (News Items) entram na lista. ' +
        'Vazio usa /transparencia/consultas-publicas.',
      widget: 'object_browser',
      mode: 'link',
      allowExternals: false,
    },
  },
  required: [],
});

export default ConsultationSearchSchema;
